import { inject, Injectable } from '@angular/core';
import { Apollo, gql, MutationResult } from 'apollo-angular';
import { GetQuery } from '../models/shared/enums/get-query.enum';
import { Observable } from 'rxjs';
import { ApolloQueryResult } from '@apollo/client/core';
import { MutationQuery } from '../models/shared/enums/mutation-query.enum';
import { MutationResponse } from '../models/shared/types/mutation-response.type';

@Injectable({
  providedIn: 'root'
})
export class GraphQLService {
  readonly #apollo = inject(Apollo);

  getData<T>(query: GetQuery, variables?: any): Observable<ApolloQueryResult<T>> {
    return this.#apollo.query<T>({query: gql`${query}`, variables, fetchPolicy: 'no-cache' });
  }

  postData(mutation: MutationQuery, variables?: any): Observable<MutationResult<MutationResponse>> {
    return this.#apollo.mutate({
      mutation: gql`${mutation}`,
      variables,
      fetchPolicy: 'no-cache',
    });
  }
}
